import { useTranslation } from 'react-i18next';
import { Badge, Card } from '@/components/ui';
import { formatRM } from '@/features/billing/money';
import type { LimitBillingSplit } from './api';
import styles from './LimitBilling.module.css';

export function OverLimitPatientPaySplit({
  split,
  status,
}: {
  split: LimitBillingSplit;
  status: 'within_limit' | 'near_limit' | 'over_limit';
}) {
  const { t } = useTranslation();
  return (
    <Card
      title={t('limitBilling.splitTitle')}
      actions={
        <Badge tone={status === 'over_limit' ? 'warning' : 'neutral'}>
          {t(`limitBilling.status.${status}`)}
        </Badge>
      }
    >
      <div className={styles.stack}>
        <p className={styles.note}>{t('limitBilling.splitBody')}</p>
        <dl className={styles.split}>
          <div>
            <dt>{t('limitBilling.eligibleTotal')}</dt>
            <dd>{formatRM(split.eligibleTotalSen)}</dd>
          </div>
          <div>
            <dt>{t('limitBilling.panelPays')}</dt>
            <dd>{formatRM(split.panelCoverageSen)}</dd>
          </div>
          <div className={styles.patientShare}>
            <dt>{t('limitBilling.patientPays')}</dt>
            <dd>{formatRM(split.patientPaySen)}</dd>
          </div>
        </dl>
        {split.patientPaySen > 0 && (
          <p className={styles.warning}>{t('limitBilling.patientPayNotice')}</p>
        )}
      </div>
    </Card>
  );
}
